module.exports = __webpack_public_path__ + "static/media/icn-chiamata.b46e7c76.svg";